module.exports = __webpack_public_path__ + "static/media/gradient-mode-uniform.a1c6e94c.svg";